<template>
    <app-page-content>
        <app-title>Solicitar Asistencia</app-title>
        <v-container>
            <v-layout>
                <v-flex xs12>
                    <v-alert type="info" outline :value="true" class="title">
                        Recuerde que esta opción es para casos de emergencia y debe estar en las instalaciones vigiladas por Seguridad Shatter
                    </v-alert>
                </v-flex>
            </v-layout>
            <v-layout column>
                <v-flex>
                    <v-btn color="green" class="mega-button white--text" large block @click="requestAssistance">Solicitar Asistencia</v-btn>
                </v-flex>
            </v-layout>
            <v-layout column>
                <v-flex>
                    <v-btn color="secondary" class="mega-button" large block @click="$router.go(-1)">Cancelar</v-btn>
                </v-flex>
            </v-layout>
        </v-container>
    </app-page-content>
</template>
<script>
import servicesRepository from '../../repositories/services.repository';
export default {
    name: 'request_assistance',
    methods: {
        async requestAssistance() {
            const sr = {...servicesRepository};
            try {

                const {data: {status, msg}} = await sr.requestAssistance(this.user.id);

                if(status) {
                    toastr.success(msg);
                } else {
                    toastr.error(msg);
                }
            } catch(err) {
                toastr.error('La asistencia no esta disponible en este momento');
            }

        }
    }
}
</script>
<style scoped>
    .mega-button {
        height: 200px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/Assistance/RequestAssistance.vue